import React from 'react'
import Card from 'react-bootstrap/Card'
import {MDBTable, MDBTableHead, MDBTableBody} from 'mdbreact'
import {AuditContext} from '../../../context/Audits'
import Spinner from 'react-bootstrap/Spinner'

function ItemPopup({auditid, entityid, itemid, handleClose, displayField, entityKey}) {
  const {itemHistory, getItemHistory} = React.useContext(AuditContext)

  React.useEffect(() => {
    if (itemid !== null) {
      getItemHistory({auditid, entityid, itemid})
    }
  }, [getItemHistory, auditid, entityid, itemid])

  const openAssetDetails = () => {
    const current_location = localStorage.getItem('parent_origin')
    window.open(current_location + `/${entityKey}/${itemid}`, '_blank')
  }

  return itemid !== null ? (
    <>
      <Card className="audit_list_expand audit_list_card">
        <div className="arrow"></div>
        <Card.Title className="audit_item_popup">{displayField}</Card.Title>
        <div class="action-back-list cursor_pointer">
          <div
            onClick={handleClose}
            class="audit-icon--close audit-icon--12 audit-icon--black cursor_pointer ml_8"
            tabindex="0"
          ></div>
        </div>
        {!itemHistory.isLoading && itemHistory ? (
          <Card.Body className="pt-0">
            <div className="row">
              <span className=" col-md-4 mb-2 audit__label">
                Comments
                <p className="audit__label item-comments">
                  {itemHistory.itemHistory.comment && itemHistory.itemHistory.comment}
                </p>
              </span>
              <div className="pl-0 col-md-8">
                <span className="mb-2 audit__label">Changed Field</span>
                {itemHistory.itemHistory.object_history &&
                itemHistory.itemHistory.object_history.length ? (
                  <div className="audit-tab__table w-100 item-table">
                    <div class="tbl-header item-history-head">
                      <MDBTable>
                        <MDBTableHead>
                          <tr>
                            <th>Field</th>
                            <th>From</th>
                            <th>To</th>
                          </tr>
                        </MDBTableHead>
                      </MDBTable>
                    </div>
                    <div class="tbl-content item-history-body">
                      <MDBTable>
                        <MDBTableBody>
                          {itemHistory.itemHistory.object_history.map(change => {
                            return (
                              <tr class="audit-table__row item-history-table__row--body">
                                <td class="audit-table__cell width_33">
                                  {itemHistory.itemHistory.fields[change.field]}
                                </td>
                                <td class="audit-table__cell width_33">{change.old_value}</td>
                                <td class="audit-table__cell width_33">{change.new_value}</td>
                              </tr>
                            )
                          })}
                        </MDBTableBody>
                      </MDBTable>
                    </div>
                  </div>
                ) : (
                  <span className="ml-1">No Changes</span>
                )}
              </div>
              <button type="button" class="btn-audit_list" onClick={() => openAssetDetails()}>
                View Details
              </button>
            </div>
          </Card.Body>
        ) : (
          <Card.Body className="pt-0">
            <Spinner
              className="spinner"
              animation="border"
              role="status"
              style={{color: '#307aff'}}
            />
          </Card.Body>
        )}
      </Card>
    </>
  ) : (
    ''
  )
}

export default ItemPopup
